import PropTypes from 'prop-types';

export const MultiselectTypes = {
	LIST: 'LIST',
	TABLE: 'TABLE',
};

export const multiselectPropTypes = {
	name: PropTypes.string,
	title: PropTypes.string,
	actionTitle: PropTypes.string,
	options: PropTypes.oneOfType([
		//list
		PropTypes.arrayOf(
			PropTypes.shape({
				value: PropTypes.string.isRequired,
				isSelected: PropTypes.bool,
			})
		).isRequired,
		//table
		PropTypes.shape({
			headers: PropTypes.objectOf(PropTypes.string),
			values: PropTypes.arrayOf(
				PropTypes.shape({
					Key: PropTypes.string,
					Value: PropTypes.string,
					Validation: PropTypes.shape({
						Key: PropTypes.string,
						ErrorMessage: PropTypes.string,
					}),
					isSelected: PropTypes.bool,
				})
			),
		}).isRequired,
	]).isRequired,
	settings: PropTypes.shape({
		type: PropTypes.oneOf(Object.values(MultiselectTypes)).isRequired,
		isFilterable: PropTypes.bool,
		filterHandler: PropTypes.func,
		isSearchable: PropTypes.bool,
		searchHandler: PropTypes.func,
		isSelectAllable: PropTypes.bool,
		selectHandler: PropTypes.func,
		selectAllHandler: PropTypes.func,
		isSortable: PropTypes.bool,
		sortHandler: PropTypes.func,
		isDisabled: PropTypes.bool,
		isReadOnly: PropTypes.bool,
		chipHandler: PropTypes.func,
	}),
};
